import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	title: {
		marginBottom: theme.spacing.small,
	},
	descriptionWrapperWrapperContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	collapsedDescription: {
		maxHeight: '200px',
		overflow: 'hidden',
		transition: 'max-height 0.3s ease-out',
	},
	toggled: {
		'&&': {
			/** Don't care too much about the height; we want to show all content we've */
			maxHeight: '99999px',
		},
	},
}));
